module.exports = require('./helpers/bundle-url').getBundleURL('aWUjo') + "apta-logo-200-2022.c0361d1b.png";